/** Notes have no separate title column. Use a bounded first line for lists;
 * never mutate or replace the stored content. */
export function noteTitle(content: string, fallback: string): string {
  const firstLine = content.split(/\r?\n/).find(line => line.trim()) ?? "";
  const plain = firstLine.trim().replace(/^#{1,6}\s+/, "").replace(/\s+/g, " ");
  const chars = Array.from(plain);
  return chars.length > 80 ? chars.slice(0, 79).join("") + "…" : plain || fallback;
}
